<template>
  <div id="testimonial-area" class="container">
    <h6 class="subtitle text-title">Our Customer Reviews</h6>
    <swiper
      :loop="true"
      :speed="1400"
      :spaceBetween="25"
      :grabCursor="true"
      :effect="'flip'"
      :pagination="{
        el: '.testimonial-pagination',
        clickable: true,
      }"
      :modules="modules"
      class="home_two-testimonial-slider"
    >
      <swiper-slide v-for="testimonial in testimonials" :key="testimonial.id">
        <div class="testimonial-card">
          <div class="row">
            <div class="col-xl-10 col-md-11">
              <p class="fs-52 lh-64 fw-normal f-secondary text-title">
                {{ testimonial.description }}
              </p>
              <div class="d-flex align-items-center justify-content-between">
                <div class="client-info-wrap d-flex">
                  <div class="client-img rounded-circle">
                    <img :src="testimonial.image" alt="Image" />
                  </div>
                  <div class="client-info">
                    <h6 class="fs-20 fw-medium text-title mb-0">
                      {{ testimonial.name }}
                    </h6>
                    <span class="lh-1">
                      {{ testimonial.designation }}
                    </span>
                  </div>
                </div>
                <span class="quote-icon">
                  <img src="../../assets/img/icons/quote-2.svg" alt="Image" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="testimonial-pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { EffectFlip, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/effect-flip";
import "swiper/css/pagination";

export default {
  name: "OurCustomerReviews",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          description:
            "“Go after leads more effectively, find out the status of the sales cycle, and optimize efforts. Automate with powerful tools for maximum efficiency this design.”",
          image: require("../../assets/img/blog/avatar-1.webp"),
          name: "John Smith",
          designation: "Product Designer",
        },
        {
          id: 2,
          description:
            "“Go after leads more effectively, find out the status of the sales cycle, and optimize efforts. Automate with powerful tools for maximum efficiency this design.”",
          image: require("../../assets/img/blog/avatar-2.webp"),
          name: "Alexander Sullivan",
          designation: "Web Designer",
        },
        {
          id: 3,
          description:
            "“Go after leads more effectively, find out the status of the sales cycle, and optimize efforts. Automate with powerful tools for maximum efficiency this design.”",
          image: require("../../assets/img/blog/avatar-3.webp"),
          name: "Samuel Harrison",
          designation: "Product Designer",
        },
        {
          id: 4,
          description:
            "“Go after leads more effectively, find out the status of the sales cycle, and optimize efforts. Automate with powerful tools for maximum efficiency this design.”",
          image: require("../../assets/img/blog/avatar-1.webp"),
          name: "William Thornton",
          designation: "Web Designer",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [EffectFlip, Pagination],
    };
  },
};
</script>

<style lang="scss" scoped>
.home_two-testimonial-slider {
  position: relative;
  .testimonial-card {
    .client-info-wrap {
      .client-img {
        width: 53px;
        height: 53px;
        position: relative;
        top: -2px;
      }
      .client-info {
        margin-left: 13px;
        width: calc(100% - 66px);
      }
    }
    p {
      margin-bottom: 56px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .home_two-testimonial-slider {
    .testimonial-card {
      .client-info-wrap {
        width: calc(100% - 42px);
      }
      p {
        margin-bottom: 35px;
      }
    }
  }
}
</style>